<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>材料管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <div>
            <div class="filter">
              <el-form
                :inline="true"
                :model="filter"
                ref="filterForm"
                label-position="right"
                label-width="80px"
                class="search-form"
                size="small"
              >
                <el-form-item label="仓库" prop="stockroom_id" v-if="!admin">
                  <stockroom-select
                    :val="filter.stockroom_id"
                    @change="filter.stockroom_id = $event"
                  ></stockroom-select>
                </el-form-item>
                <el-form-item label="关键字" prop="query">
                  <el-input
                    v-model="filter.query"
                    placeholder="名称或编码"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="查询范围"
                  prop="all_stockroom"
                  v-if="admin"
                >
                  <el-checkbox v-model="filter.all_stockroom"
                    >所有仓库</el-checkbox
                  >
                </el-form-item>
              </el-form>
              <div style="margin-left: 80px">
                <el-button
                  type="primary"
                  size="small"
                  @click="
                    filter.page = 1
                    getData()
                  "
                  >筛选</el-button
                >
                <el-button size="small" @click="getData(true)">重置</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="panel">
          <!-- <btn-tag
            v-if="admin"
            :btn="true"
            :text="'添加' + $route.meta.name"
            :auth-id="51301"
            btn-class="btn-purple"
            icon-class="ion-plus-circled"
            module-name="stock"
            @click.native="formerVisible = true"
          ></btn-tag> -->
          <div style="display: flex; justify-content: space-between">
            <CommodityCategoryFilter
              v-model="filter.commodity_category"
              @change="commodityCategoryChange"
            ></CommodityCategoryFilter>
            <div style="display: flex">
              <file-button
                class="mr-10"
                obj="item_inventory"
                :filter="filter"
                :importButton="false"
                exportBtnName="导出"
              ></file-button>
              <!-- <file-button
                obj="item_inventory"
                :importButton="false"
                exportBtnName="导出本月出入库明细"
              ></file-button> -->
            </div>
          </div>
          <item-table
            :items="items"
            :admin="admin"
            :category="filter.commodity_category"
            v-loading="loading"
          ></item-table>
          <el-pagination
            background
            class="m-t-20 text-right"
            :page-size="filter.size"
            :current-page.sync="filter.page"
            @current-change="getData()"
            layout="total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <item-former
      :model="model"
      :show.sync="formerVisible"
      @created="createdCallback"
    ></item-former>
  </div>
</template>

<script>
import { itemList } from '@/service/getData'
import ItemTable from './table'
import ItemFormer from '@/components/item_former'
import { getStore } from '@/config/mUtils'
import StockroomSelect from '@/components/select/stockroom_select'
import CommodityCategoryFilter from '@/components/select/commodity_category_filter.vue'

export default {
  components: {
    ItemTable,
    ItemFormer,
    StockroomSelect,
    CommodityCategoryFilter,
  },
  data() {
    return {
      loading: false,
      admin: getStore('userInfo').is_stockroom_admin,
      filter: {
        commodity_category: 0,
        page: 1,
        size: 20,
        query: '',
        stockroom_id: '',
        all_stockroom: false,
      },
      model: {
        name: '',
        code: '',
        specification: '',
        model_number: '',
        unit: '',
        remark: '',
      },
      formerVisible: false,
      items: [],
      total: 0,
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
  },
  methods: {
    commodityCategoryChange(e) {
      this.filter.commodity_category = e.id
      this.filter.page = 1
      this.getData()
    },
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.query = ''
        this.filter.stockroom_id = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1

      params.filter_zero = true

      this.loading = true
      let res = await itemList(params)
      if (res.status == 0) {
        this.items = res.data.list
        this.total = res.data.count
      }
      this.loading = false
    },
    createdCallback(item) {
      this.items.unshift(item)
    },
  },
}
</script>